export default {
    company_role: {
        admin: 'ADMIN',
        user: 'USER',
    },
    click_email: 'Click for email',
    click_phone: 'Click for phone',
}
